import React, { useEffect } from "react";
// import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconContext } from "react-icons";
import styled from "styled-components";
import { Container, Image, Nav, Navbar, NavbarCollapse } from "react-bootstrap";
import { logout } from "../../features/UserProfie";

import dummy from "../../images/person-outline.png";
import { TestImage } from "../../core/Helper";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import ConfirmDialogB from "./ConfirmDialogB";

import BallTriangle from "react-loading-icons/dist/esm/components/ball-triangle";
import { NotifyMessageService } from "../../model/notify-message";
import { useMemo } from "react";
import { MessageOffCanvas } from "./A01_Navbar_OffCanvas";
import { MenuOffCanvas } from "./A01_Navbar_MenuCanvas";
import { ontLogo } from "./A01_Navbar";
import "./navbar-ont.css";

export function NavbarOLD() {
  const userDetail = useSelector((state) => state.user.detail);
  const userLineProfile = useSelector((state) => state.user.lineProfile);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const mousePosX = useSelector((state) => state.scrollTrack.mousePos.x);

  const theme = useSelector((s) => s.theme.theme);
  const [sidebar, setSidebar] = useState(false);
  const [loginTimeOut, setLoginTimeout] = useState(0);
  const [oldMouseX, setOldX] = useState(0);
  const [messageBar, setMessageBar] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [messages, setMessages] = useState([]);
  const [msgCounted, setMsgCounted] = useState(0);
  const user = useSelector((state) => state.user);
  const [foundImage, setFoundImage] = useState(false);
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const dispatch = useDispatch();
  const [acceptLine, setAcceptLine] = useState(false);
  const TIMEOUT = 1800;

  useEffect(() => {
    setAcceptLine(true);

    TestImage(userLineProfile[0]?.pict_url)
      .then((ret) => {
        setFoundImage(true);
      })
      .catch((err) => setFoundImage(false));
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSidebar(false);
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    //เวลาเกิน 60 นาที logout
    if (mousePosX === oldMouseX) {
      if (loginTimeOut > TIMEOUT) {
        handleLogout();
      }
    } else {
      setLoginTimeout(0);
    }

    const intervalId = setInterval(() => {
      if (loginTimeOut % 15 === 1) {
        loadNewMessageCoutner();
      }
      setLoginTimeout(loginTimeOut + 1);
      setOldX(mousePosX);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [loginTimeOut]);

  const updateLineMessager = (value) => {
    axios
      .post(
        process.env.REACT_APP_API +
          "api/notify-message/accepted-linemessage-setup",
        {
          UserInfo: userDetail,
          LineAccepted: value == true ? "y" : "n",
        },
        HttpJsonHeader
      )
      .then((res) => {
        setAcceptLine(value);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClose = () => {
    setSidebar(false);
  };

  const handleOnlieBar = () => {
    setMessageBar(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("raduser");
    dispatch(logout());
  };

  const removeAllMessage = async () => {
    let res = await NotifyMessageService.RemoveALLUserMessage({
      UserInfo: userDetail,
    });
    setMessageBar(false);
  };
  const handleConfirm = () => {
    setConfirm({
      show: true,
      title: "ยืนยันการยกเลิกข้อความทั้งหมด",
      action: (data) => {
        if (data === true) {
          removeAllMessage();
        }
      },
    });
  };

  const loadNewMessageCoutner = async () => {
    let res = await NotifyMessageService.GetUserMessageCounted({
      UserInfo: userDetail,
    });

    if (res) {
      setMsgCounted(res.MessageCounted);
    } else {
      setMsgCounted(0);
    }
  };

  const messageCanvas = useMemo(
    () => (
      <MessageOffCanvas
        {...{
          messageBar: [messageBar, setMessageBar],
          deleting: [deleting, setDeleting],
          messages: [messages, setMessages],
          handleOnlieBar: handleOnlieBar,
          handleConfirm: handleConfirm,
          styles: styles,
        }}
      />
    ),
    [messageBar, messages]
  );

  const menuCanvas = useMemo(
    () => (
      <MenuOffCanvas
        {...{
          sidebar: [sidebar, setSidebar],
          foundImage: [foundImage, setFoundImage],
          handleClose: handleClose,
          styles: styles,
          handleLogout: handleLogout,
        }}
      />
    ),
    [sidebar]
  );

  const mainPage = useMemo(() => {
    return (
      <IconContext.Provider value={{ color: "#fff", size: "20px" }}>
        <div className="navbar-ont">
          {/* {console.log(user)} */}
          {user.userRule.flag_super == "y" ? (
            <Link to="#" className="menu-bars">
              <div class="menu-icon" onMouseUp={() => setSidebar(true)}>
                ☰
              </div>
            </Link>
          ) : (
            <></>
          )}
          <LogoWrapper>{ontLogo}</LogoWrapper>

          <Navbar>
            <Container class="nav-container">
              <NavbarCollapse>
                <Nav>
                  {user.userRule.flag_super === "n" &&
                    user.userMenus?.map((item, index) => {
                      return (
                        <Navbar.Brand>
                          <LinkB to={item.linkto}>{item.menutext}</LinkB>
                        </Navbar.Brand>
                      );
                    })}
                </Nav>
              </NavbarCollapse>
            </Container>
          </Navbar>

          <UserDetailBox
            style={{
              flex: "initial",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <UserLineText>
              {`${userDetail.prefix}${userDetail.firstname}`}
            </UserLineText>
            <UserLineText style={{ color: "#bd05eb" }}>
              {userDetail.stafftypename}
            </UserLineText>
            <UserLineText style={{ color: "var(--fore-primary)" }}>
              {`สาขา${userDetail.brchname}`}
            </UserLineText>
          </UserDetailBox>
          <UserDetailBox style={styles.userDetailBoxMain}>
            <div style={styles.userDetailBoxSub}>
              <Image
                style={{
                  position: "relative",
                  top: foundImage ? "-1px" : "-12px",
                  left: foundImage ? "0px" : "-10px",
                  width: foundImage ? "60px" : "80px",
                  height: foundImage ? "60px" : "80px",
                }}
                src={userLineProfile[0]?.pict_url || dummy}
              />
            </div>
            <button
              class="logout-btn"
              onMouseUp={() => {
                handleLogout();
              }}
            >
              Logout
            </button>
          </UserDetailBox>

          {TIMEOUT - loginTimeOut < 60 ? (
            <CountdownBox>
              <BallTriangle color="#64f013" />

              <div style={{ fontSize: "20px", padding: "30px 10px 5px 10px" }}>
                กำลังออกจากระบบภายใน ...
              </div>
              <div
                style={{ fontSize: "80px", margin: "10px", color: "#0dec45" }}
              >
                {`${TIMEOUT - loginTimeOut}`}
              </div>
              <div>กรุณาเลื่อนหรือกดปุ่มเม้าส์</div>
            </CountdownBox>
          ) : (
            <></>
          )}
        </div>
      </IconContext.Provider>
    );
  }, [loginTimeOut, msgCounted]);

  return (
    <>
      <TransparentBar
        onMouseOver={() => {
          // setSidebar(true);
        }}
      />

      {mainPage}
      {messageCanvas}
      {menuCanvas}

      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </>
  );
}

export default React.memo(NavbarOLD);

const TransparentBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 15px;
  z-index: 5;
`;

const UserDetailBox = styled.div`
  padding-inline: 10px;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const UserLineText = styled.p`
  text-align: center;
  padding: 0px;
  margin: 0 0 0 20px;
  height: 20px;
  font-size: 14px;
  flex: 1;
  color: #bd05eb;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const styles = {
  messageBar: {
    background: "#141414",
    width: "400px",
  },
  messageBarHeader: {
    backgroundColor: "#0b46c5",
    fontSize: "17px",
    color: "#ebf3eb",
    width: "100%",
    justifyContent: "space-between",
  },
  messagebarBody: {
    flexGrow: "1",
    display: "flex",
    flex: "1",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
    height: "100%",
  },

  imageBoxFrame: {
    borderRadius: "50px",
    overflow: "hidden",
    width: "80px",
    height: "80px",
    margin: "10px 10px 10px 10px",
    background: "var(--bg-primary)",
    border: "2px solid #0a86f3",
  },

  userDetailBoxMain: {
    borderRadius: "10px 0px",
    maxWidth: "50px",
    height: "100%",
    marginRight: "20px",
  },

  userDetailBoxSub: {
    position: "relative",
    height: "60px",
    width: "60px",
    borderRadius: "30px 30px 30px 30px",
    top: "0px",
    left: "0px",
    overflow: "hidden",
    background: "#999191",
    border: "2px solid #0a86f3",
  },
  staffBox: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  menuFrameCover: {
    flex: "0.5",
    margin: "20px 0 0 0",
    color: "#838181",
    display: "flex",
    justifyContent: "center",
  },
  menuFrame: {
    flex: "10",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "stretch",
    border: "1px solid #726b6b", //995151
    width: "100%",
    padding: "20px 0px 10px 0px",
    borderRadius: "10px 10px 10px 10px",
    margin: "0px 0 5px 0 ",
  },

  BadgeCaption: {
    fontSize: "12px",
    color: "var(--fore-primary)",
    marginTop: "2px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  BadgeCaptionNumber: {
    color: "#f5f1eb",
    borderRadius: "5px",
    backgroundColor: "red",
    textAlign: "center",
    width: "20px",
    padding: "0 2px 0 2px",
    marginTop: "-40px",
    marginLeft: "30px",
  },

  versionBox: {
    fontSize: "10px",
    display: "flex",
    margin: "2px 2px 2px 2px",
    width: "180px",
    // border: "1px solid yellow",
    color: "var(--fore-primary)",
    justifyContent: "center",
  },
  versionBoxSpan1: {
    margin: "1px 1px 1px 1px",
  },

  offCanvasDiv1: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
    height: "93%",
  },
};

const CountdownBox = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 600px;
  top: 25vh;
  left: 25vw;
  z-index: 5000;
  color: #1b90fd;
  background-color: #47167e;
  padding: 50px;
  border-radius: 10px;
  opacity: 0.8;
  transition: 0.3s ease-in;
  box-shadow: 1px 1px 50px #5e5b5b;
`;

const HSpliter = styled.div`
  width: 0.1px;
  opacity: 0.7;
  height: 50px;
  background-color: var(--bg-primary);
`;

const bannerIcon = {
  // color: "var(--x-fore-banner-icon)",
  color: "var(--fore-primary)",
  marginBlock: "2px",
};

const LinkB = styled(Link)`
  text-decoration: none;
  display: flexbox;
  margin-top: 0px;
  margin-left: 0px;
  padding-inline: 10px;
  border-radius: 5px;
  padding-block: 20px;
  color: #3b3a3a;
  font-size: 14px;
  /* background: #2cffff; */
  /* border: 1px solid #eeeeee; */
  &:hover {
    /* background: yellow; */
    color: white;
  }
`;

const LogoWrapper = styled.div`
  flex: 1;
  max-width: 180px;
  overflow-x: hidden;
  /* border: 1px solid black; */
  padding-left: 10px;
  padding-block: 10px;
  background-color: rgba(164, 238, 186, 1);
  border-radius: 20px;
`;
